import { i18n } from 'next-i18next'
import en from '../countries/en.json'
import es from '../countries/es.json'
import fr from '../countries/fr.json'
import ko from '../countries/ko.json'
import de from '../countries/de.json'
import pt from '../countries/pt.json'
import it from '../countries/it.json'
import pl from '../countries/pl.json'
import zh from '../countries/zh.json'
import { PosibleLocale } from 'src/core/models'

const countries = { en, es, fr, ko, de, pt, it, pl, zh }

export const getCountryName = (code2: string, name: string, defaultLanguage?: PosibleLocale): string => {
  const language = defaultLanguage || i18n.language
  const countryList = countries[language || 'en']['countries']
  return countryList[code2] || name
}
